import { Box, Skeleton, Stack, Typography } from "@mui/material";

export interface MessageSkeletonProps {
    height: number;
}

export const MessagesSkeleton = (props: MessageSkeletonProps) => {
        return <Box sx={{ padding: 2, border: "1px gray solid", backgroundColor: "#EEEEEE", height: props.height, overflowY: "scroll" }}>
            <Box sx={{ marginLeft: 16, marginY: 1 }}>
                <Stack direction="row" spacing={1}>
                    <Box sx={{ width: "100%", padding: 1, borderRadius: 2, border: "1px lightgray solid" }}>
                        <Stack direction="column" spacing={1}>
                            <Typography variant="body2" component="span" color='white'>
                                <Skeleton sx={{ height: "64x" }} />
                            </Typography>
                            <Typography variant="caption" component="span" sx={{ textAlign: "right" }}>
                                <Skeleton sx={{ height: "64x" }} />
                            </Typography>
                        </Stack>
                    </Box>
                </Stack>
            </Box>
            <Box sx={{ marginRight: 16, marginY: 1 }}>
                <Stack direction="row" spacing={1}>
                    <Box sx={{ width: "100%", padding: 1, borderRadius: 2, border: "1px lightgray solid" }}>
                        <Stack direction="column" spacing={1}>
                            <Typography variant="body2" component="span" color='white'>
                                <Skeleton sx={{ height: "64x" }} />
                            </Typography>
                            <Typography variant="caption" component="span" sx={{ textAlign: "right" }}>
                                <Skeleton sx={{ height: "64x" }} />
                            </Typography>
                        </Stack>
                    </Box>
                </Stack>
            </Box>
            <Box sx={{ marginLeft: 16, marginY: 1 }}>
                <Stack direction="row" spacing={1}>
                    <Box sx={{ width: "100%", padding: 1, borderRadius: 2, border: "1px lightgray solid" }}>
                        <Stack direction="column" spacing={1}>
                            <Typography variant="body2" component="span" color='white'>
                                <Skeleton sx={{ height: "64x" }} />
                            </Typography>
                            <Typography variant="caption" component="span" sx={{ textAlign: "right" }}>
                                <Skeleton sx={{ height: "64x" }} />
                            </Typography>
                        </Stack>
                    </Box>
                </Stack>
            </Box>
            <Box sx={{ marginRight: 16, marginY: 1 }}>
                <Stack direction="row" spacing={1}>
                    <Box sx={{ width: "100%", padding: 1, borderRadius: 2, border: "1px lightgray solid" }}>
                        <Stack direction="column" spacing={1}>
                            <Typography variant="body2" component="span" color='white'>
                                <Skeleton sx={{ height: "64x" }} />
                            </Typography>
                            <Typography variant="caption" component="span" sx={{ textAlign: "right" }}>
                                <Skeleton sx={{ height: "64x" }} />
                            </Typography>
                        </Stack>
                    </Box>
                </Stack>
            </Box>
        </Box>;
};